import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PackageReferencesActions {
  NAME = '@APP/PACKAGE_REFERENCES',
  SET_PACKAGE_REFERENCES = '@APP/PACKAGE_REFERENCES/setPackageReferences',
  UNSET_PACKAGE_REFERENCES = '@APP/PACKAGE_REFERENCES/unsetPackageReferences'
}

export const INITIAL_PACKAGE_REFERENCES_STATE: string[] = [];

const packageReferencesSlice = createSlice({
  name: PackageReferencesActions.NAME,
  initialState: INITIAL_PACKAGE_REFERENCES_STATE,
  reducers: {
    setPackageReferences: (state, action: PayloadAction<Array<string>>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    },
    unsetPackageReferences: () => {
      return INITIAL_PACKAGE_REFERENCES_STATE;
    }
  }
});

export const { setPackageReferences, unsetPackageReferences } = packageReferencesSlice.actions;

export const packageReferencesReducer = packageReferencesSlice.reducer;
